import * as React from 'react';

export const IconSlimInvalid = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		version="1.1"
		viewBox="375 375 450 450"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		fill="currentColor"
	>
		<path d="m760.31 439.69c-5.9023-5.9023-15.473-5.9023-21.375 0l-138.94 138.94-138.93-138.94c-5.9023-5.9023-15.473-5.9023-21.375 0s-5.9023 15.473 0 21.375l138.94 138.94-138.94 138.94c-5.9023 5.9023-5.9023 15.473 0 21.375s15.473 5.9023 21.375 0l138.93-138.94 138.94 138.94c5.9023 5.9023 15.473 5.9023 21.375 0s5.9023-15.473 0-21.375l-138.94-138.94 138.94-138.93c5.9023-5.9023 5.9023-15.473 0-21.375z" />
	</svg>
);
